import { styled } from '@mui/material';
import { Box, Skeleton, Stack, useDeviceType } from '@packages/shared';

const MainContent = styled(Box)({});
const SideContent = styled(Box)({});

export const BasketSkeleton: React.FC = () => {
  const isMobile = useDeviceType();

  return (
    <Box data-testid="skeleton-basket">
      <Stack
        direction={isMobile ? 'column' : 'row'}
        justifyContent="space-between"
        flexWrap="nowrap"
      >
        <MainContent width={isMobile ? '100%' : 'calc(100% - 21.75rem'}>
          <Skeleton height="10rem" />
          <Skeleton height="10rem" />
          <Skeleton height="10rem" />
          <Skeleton height="10rem" />
          <Skeleton height="10rem" />
          <Skeleton height="10rem" />
          <Skeleton height="10rem" />
        </MainContent>
        <SideContent width={isMobile ? '100%' : '21.75rem'}>
          <Skeleton height="20rem" />
        </SideContent>
      </Stack>
    </Box>
  );
};
